<section id="fleetService">


  <div class="flex flex-col-reverse sm:flex-row gap-2 mb-8">
    <div class="flex-grow mb-2">
      <div>
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col sm:flex-col lg:flex-row sm:justify-between xl:items-center gap-4">

              <div class="flex flex-col xl:flex-row xl:items-center gap-3  justify-center xl:gap-0">

                <div class="flex flex-col xl:flex-row m-0 justify-center gap-1">
                  <nz-form-label class="text-start mt-1">Filter By Service Type: </nz-form-label>
                  <nz-select [(ngModel)]="serviceTypeFilter" (ngModelChange)="search()"
                             nzPlaceHolder="Select Service Type">
                    <nz-option nzLabel="Normal service" nzValue="NORMALSERVICE"></nz-option>
                    <nz-option nzLabel="Transmission oil change" nzValue="TRANSMISSION"></nz-option>
                  </nz-select>
                </div>

                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>

                <div class="flex flex-col xl:flex-row m-0 justify-center gap-1 custom-user_filter">
                  <nz-form-label class="text-start mt-1">Filter Service Done By: </nz-form-label>
                  <nz-select [(ngModel)]="serviceDoneByFilter" (ngModelChange)="search()"
                             nzPlaceHolder="Select User">
                    <nz-option nzValue="SR" nzLabel="SR"></nz-option>
                    <nz-option nzValue="OWNER" nzLabel="Vehicle Owner"></nz-option>
                  </nz-select>
                </div>
              </div>
              <div>
                <button nz-button nzBlock class="outline-button btn_reset_search" (click)="resetSearch()">
                  Reset All
                </button>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>
    <button *appHasAnyPrivilege="'SERVICE_RECORDS_CREATE'" nz-button nzType="primary"
            routerLink="/admin/fleets/{{fleetData._id}}/service/add-edit">
      New Service Record
    </button>
  </div>

  <div>
    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
      <div class="table-obj">
        <nz-table #basicTable [nzData]="servicesData" [nzShowSizeChanger]="pageSize.length > 5"
                  [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                  [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                  (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto', y: '550px' }"
                  nzOuterBordered class="table-wSpace-nowrap">
          <thead>
          <tr>
            <th>Service No.</th>
            <th>Service Done By.</th>
            <th>Service Type</th>
            <th>
              <div class="flex">
                <span>Service Date & Time</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
              </div>
            </th>
            <th>Current Millage</th>
            <th>Next Service Due In</th>
            <th *appHasAnyPrivilege="'SERVICE_RECORDS_SINGLE_VIEW,SERVICE_RECORDS_DELETE,SERVICE_RECORDS_UPDATE'">
              Actions
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td style="white-space: nowrap; min-width: 100px">
              <a *appHasAnyPrivilege="'SERVICE_RECORDS_SINGLE_VIEW'"
                 (click)="viewServiceRecords(data._id)">{{data?.refNo ? data?.refNo : '-'}}</a>
              <span *ngIf="!hasPermission('SERVICE_RECORDS_SINGLE_VIEW')">{{data?.refNo ? data?.refNo : '-'}}</span>
            </td>
            <td style="white-space: nowrap; min-width: 200px">{{data?.serviceType === 'NORMALSERVICE' ? labelValOnServiceType(data.fleet?.vehicleInventory?.serviceResponsible) : labelValOnServiceType(data.fleet?.vehicleInventory?.serviceOilChangeResponsible)}}</td>
            <td style="white-space: nowrap; min-width: 200px">
              {{data?.serviceType === 'NORMALSERVICE' ? 'Normal Service' : 'Transmission'
              }}
            </td>
            <td style="white-space: nowrap; min-width: 200px">{{ data?.createdAt | date: "dd-MM-y | hh:mm aa"}}</td>
            <td style="white-space: nowrap; min-width: 200px">{{data.currentMileage}} km</td>
            <td style="white-space: nowrap; min-width: 200px">
              {{data?.currentMileage + fleetData?.vehicleInventory?.serviceDuration}} km
            </td>
            <td style="white-space: nowrap; min-width: 200px" *appHasAnyPrivilege="'SERVICE_RECORDS_SINGLE_VIEW,SERVICE_RECORDS_DELETE,SERVICE_RECORDS_UPDATE'">
              <div class="flex gap-1">
                <button *appHasAnyPrivilege="'SERVICE_RECORDS_UPDATE'"
                        routerLink="/admin/fleets/{{fleetData?._id}}/service/add-edit/{{data?._id}}"
                        class="outline-button mr-3" nz-button nzType="default">
                  Edit
                </button>
                <button *appHasAnyPrivilege="'SERVICE_RECORDS_SINGLE_VIEW,SERVICE_RECORDS_DELETE'"
                        class="outline-button more-dropdown" nz-button nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter">
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *appHasAnyPrivilege="'SERVICE_RECORDS_SINGLE_VIEW'" nz-menu-item
                        (click)="viewServiceRecords(data._id)">
                      View
                    </li>
                    <li *appHasAnyPrivilege="'SERVICE_RECORDS_DELETE'" nz-menu-item nz-popconfirm nz-button nzDanger
                        nzPopconfirmTitle="Are you sure you want to delete this service record?"
                        (nzOnConfirm)="softDeleteConfirm(data._id)" (nzOnCancel)="cancel()">
                      Delete
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </div>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-table-skeleton-template [columnData]="skeletonTableColumns"
                                   [showAdvanceSearch]="false"></app-table-skeleton-template>
    </div>
  </div>
</section>
